import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/select.scss'
import BottomSheet from 'components/BottomSheet'

function Element({ list = [], readOnly = false, className, onClick = () => {} }) {
  // bottomsheet control
  const [_bottomsheet, setBottomsheet] = useState(false)
  const [listItems, setListItems] = useState(list.map((item, idx) => ({ ...item, _key: idx })))
  const handleBottomSheet = () => {
    console.log('_bottomsheet', _bottomsheet)
    if (!readOnly) setBottomsheet(!_bottomsheet)
  }
  return (
    <>
      <div className={' ' + className}>
        <span className="input-select block" onClick={handleBottomSheet}>
          {listItems.find(({ active }) => active)?.text || '선택해 주세요'}
        </span>
      </div>
      <BottomSheet
        show={_bottomsheet}
        onCancel={handleBottomSheet}
        onClick={(item) => {
          setListItems(
            listItems.map((listItem) => {
              listItem.active = false
              if (listItem._key === item._key) {
                listItem.active = true
                onClick(listItem)
              }
              return listItem
            }),
          )
        }}
        title="사이트레시피 변경"
        list={listItems}
      />
    </>
  )
}

export default Element
